import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import VideoFileOutlinedIcon from '@mui/icons-material/VideoFileOutlined'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { RecordStageStatus, RecordStageType } from '../../swagger/dto'

export const RECORD_STAGE_TYPE_MAP = {
    [RecordStageType['RECORD_PREPARE']]: {
        label: 'Загрузка',
    },
    [RecordStageType['CONVERT']]: {
        label: 'Обработка',
    },
    [RecordStageType['STENOGRAPHY']]: {
        label: 'Стенография',
    },
    [RecordStageType['FORMATTING']]: {
        label: 'Форматирование',
    },
    [RecordStageType['MEMO']]: {
        label: 'Саммари',
    },
}
export const RECORD_STAGE_STATUS_MAP = {
    [RecordStageStatus['SCHEDULED']]: {
        icon: <ScheduleOutlinedIcon color="#1D192B" />,
        label: 'запланировано',
        color: '#1D192B',
        bg: '#E8DEF8',
    },
    [RecordStageStatus['PROCESSING']]: {
        icon: <UploadFileOutlinedIcon color="#F8FEF5" />,
        label: 'выполняется',
        color: '#004B9F',
        bg: '#F8FEF5',
    },
    [RecordStageStatus['ERROR']]: {
        icon: <HighlightOffOutlinedIcon color="#CA1616" />,
        label: 'возникла ошибка',
        color: '#CA1616',
        bg: '#FEEBEE',
    },
    [RecordStageStatus['CANCELLED']]: {
        icon: <ErrorOutlineOutlinedIcon color="#FEEBEE" />,
        label: 'отменено',
        color: '#CA1616',
        bg: '#FEEBEE',
    },
    [RecordStageStatus['COMPLETED']]: {
        icon: <InsertDriveFileOutlinedIcon color="#F8FEF5" />,
        label: 'выполнена',
        color: '#019555',
        bg: '#F8FEF5',
    },
}

export const RecordImage = ({ record, isList = false }) => {
    const isRecordLastStage = record?.last_stage ? true : false
    const label1 = isRecordLastStage
        ? RECORD_STAGE_TYPE_MAP[record.last_stage?.stage_type]?.label
        : ''
    const { label, color, bg, icon } = isRecordLastStage
        ? RECORD_STAGE_STATUS_MAP[record.last_stage.status]
        : ''

    return (
        <Paper
            sx={{
                p: 0,
                cursor: 'pointer',
                borderRadius: '6px',
                background: '#E9EAED',
                height: '104px',
                // width: '310px',
                position: 'relative',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
            }}>
            {isRecordLastStage &&
                (!isList ||
                    (isList && record?.last_stage?.status === RecordStageStatus['ERROR'])) && (
                    <Box sx={{ position: 'absolute', top: '0px', left: '0px' }}>
                        <Chip
                            component="div"
                            size="small"
                            sx={{
                                m: 0,
                                borderRadius: '8px',
                                padding: '4px',
                                // width: '100%',
                                height: '38px',
                                color: color,
                                background: bg,
                                // marginRight: '8px',
                                '&>.MuiChip-icon': {
                                    m: 0,
                                    mr: 1,
                                },
                            }}
                            icon={icon}
                            label={
                                <Box sx={{ padding: '0px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            lineHeight: '14px',
                                            fontWeight: '500',
                                        }}>
                                        {label1}
                                    </Typography>
                                    <Typography sx={{ fontSize: '11px', lineHeight: '14px' }}>
                                        {label}
                                    </Typography>
                                </Box>
                            }
                        />
                    </Box>
                )}

            {record?.source_info?.preview_url ? (
                <div
                    style={{
                        borderRadius: '8px',
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${record.source_info.preview_url})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
            ) : (
                <VideoFileOutlinedIcon sx={{ color: '#BDBFC7', fontSize: '30px' }} />
            )}
        </Paper>
    )
}
